export default {
  // 查询售后列表
  param_queryGoodBackList: {
    url: '/gb-shop-desk/order/queryRefundOrder',
    param: {}
  },
  // 查看订单列表 /shop-desk
  param_queryShopOrderInfo: {
    url: '/gb-shop-desk/order/queryShopOrderInfo',
    param: {}
  },
  // 订单支付
  param_payOrderIntegral: {
    url: '/gb-shop-trade/shopTrade/payOrder',
    param: {}
  },
  // 拼团订单支付
  param_payGroupon: {
    url: '/gb-shop-trade/shopGroupTrade/payGroupOrder',
    param: {}
  },
  // 计算运费
  param_calculateFreight: {
    url: '/gb-shop-trade/shopTrade/computeOrderShippingFee',
    param: {}
  },
  // 修改地址
  param_updateAddress: {
    url: '/gb-shop-trade/shopTrade/updateOrderAddress',
    param: {}
  },
  // 取消订单
  param_gb_cancelOrder: {
    url: '/gb-shop-trade/shopTrade/cancelOrder',
    param: {}
  },
  // 商城退货申请 传参orderDetailId id申请id /shop-trade
  param_refundOrder: {
    url: '/gb-shop-trade/shopTrade/refundOrder',
    param: {}
  },
  // 商城确认收货 传参orderDetailId
  param_confirmOrder: {
    url: '/gb-shop-trade/shopTrade/confirmOrder',
    param: {}
  },
  // 取消退货
  param_cancelRefund: {
    url: '/gb-shop-trade/shopTrade/cancelRefundOrder',
    param: {}
  },
  // 查看物流详情
  param_getLogistic: {
    url: '/shop-desk/aliDelivery/getLogistic',
    param: {}
  }
}
